/**
 * 3.0 웹과 동일: SHA-256 바이트열을 Base64 문자열로 (CryptoJS.SHA256 + Base64.stringify 대응).
 * @param {string} plainText
 * @returns {Promise<string>}
 */
export async function sha256Base64(plainText) {
  const enc = new TextEncoder().encode(plainText);
  const buf = await crypto.subtle.digest('SHA-256', enc);
  const bytes = new Uint8Array(buf);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
